/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by scripts/generate-config.js
// It replaces the auto-generated aws-exports.js from Amplify CLI

const awsmobile = {
  "aws_project_region": "eu-central-1",
  "aws_cognito_region": "eu-central-1",
  "aws_user_pools_id": "eu-central-1_jCRK19PQi",
  "aws_user_pools_web_client_id": "17dorpjdbdb245bkj2hu1gd0pc",
  "aws_appsync_graphqlEndpoint": "https://5r4cmjupdfbhhos2sadcsyqkb4.appsync-api.eu-central-1.amazonaws.com/graphql",
  "aws_appsync_region": "eu-central-1",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "oauth": {
    "domain": "d2cwiionct8d9m-main.auth.eu-central-1.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://cpe-team.aws.int.kn/",
    "redirectSignOut": "https://cpe-team.aws.int.kn/",
    "responseType": "code"
  },
  "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;
